import React from "react";
import icons from "../../icons.config";

const FAQsSection = ({ faqs, activeIndex, toggleFAQ }) => (
  <div className="relative mt-16">
    <div className="max-w-full mx-auto">
      <div className="space-y-5 ">
        {faqs.map((faq, index) => (
          <div key={index} className="border-b border-primary2 pb-2">
            <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleFAQ(index)}>
              <h3 className="text-md font-normal text-primary1">{faq.question}</h3>
              {activeIndex === index ? (
                <img src={icons.minus} alt="Collapse" className="w-4 h-4" />
              ) : (
                <img src={icons.plus} alt="Expand" className="w-5 h-5" />
              )}
            </div>
            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${
                activeIndex === index ? "max-h-[300px] opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="mt-3 text-hcolor max-w-[90%]">{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default FAQsSection;